// Background is re-introduced locally — see ./index.tsx for the reason
// (global Select theme zeroes `multipleItemBg`).
.tagItem {
  background: var(--bc-color-fill-tertiary) !important;
}
